// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.credits-section {
    height: 40px;
    /* background-color: #e4e4e4; */
    display: flex;
    flex-direction: column;
    justify-content: center;
    font-size: 10px;
    font-family: -apple-system, BlinkMacSystemFont, sans-serif;
    text-align: right;
    overflow: scroll;
    /* color: #243547; */
    color: var(--nds-base-color-60);
    margin-top: 5px;
}
.credits-section p {
    margin: 0;
    font-size: 10px;
}
.credits-section span {
    overflow-x: scroll;
}`, "",{"version":3,"sources":["webpack://./src/Components/CreditsSection/CreditsSection.css"],"names":[],"mappings":"AAAA;IACI,YAAY;IACZ,+BAA+B;IAC/B,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,eAAe;IACf,0DAA0D;IAC1D,iBAAiB;IACjB,gBAAgB;IAChB,oBAAoB;IACpB,+BAA+B;IAC/B,eAAe;AACnB;AACA;IACI,SAAS;IACT,eAAe;AACnB;AACA;IACI,kBAAkB;AACtB","sourcesContent":[".credits-section {\n    height: 40px;\n    /* background-color: #e4e4e4; */\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    font-size: 10px;\n    font-family: -apple-system, BlinkMacSystemFont, sans-serif;\n    text-align: right;\n    overflow: scroll;\n    /* color: #243547; */\n    color: var(--nds-base-color-60);\n    margin-top: 5px;\n}\n.credits-section p {\n    margin: 0;\n    font-size: 10px;\n}\n.credits-section span {\n    overflow-x: scroll;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
